module.exports = ".content-wrapper > h3 {\n  font-size: 24px;\n  line-height: 1.1;\n  color: #929292;\n  margin: -20px;\n  margin-bottom: 20px;\n  padding: 20px;\n  font-weight: 400;\n  background-color: #fafbfc;\n  border-bottom: 1px solid #cfdbe2; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main